import { render, staticRenderFns } from "./_NavItem.vue?vue&type=template&id=7b287632&"
import script from "./_NavItem.vue?vue&type=script&lang=js&"
export * from "./_NavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports